import { render, staticRenderFns } from "./userInfoForm.vue?vue&type=template&id=b7b8737e&scoped=true&"
import script from "./userInfoForm.vue?vue&type=script&lang=js&"
export * from "./userInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./userInfoForm.vue?vue&type=style&index=0&id=b7b8737e&prod&lang=scss&scoped=true&"
import style1 from "./userInfoForm.vue?vue&type=style&index=1&id=b7b8737e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b8737e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Verification: require('/var/jenkins_home/workspace/prod-web-xfans/components/verificationCode/verification.vue').default})
